export function objectSlice(object, length) {
    return Object
        .keys(object)
        .slice(0, length)
        .reduce((slicedObj, key) => {
            slicedObj[key] = object[key];
            return slicedObj;
        }, {});
}